import { i18n } from '../config';

export default (subscription) => {
  if (!subscription) return null;

  const key = 'report.subscription.period';

  if (subscription.period < 12) {
    return i18n.global.t(`${key}.month`, subscription.period, { count: subscription.period });
  }

  const years = Number((subscription.period / 12).toFixed(1));

  return i18n.global.t(`${key}.year`, years, { count: years });
};
